import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/svg/global.svg'


const _hoisted_1 = { class: "lang-wrapper" }
const _hoisted_2 = { class: "lang-title" }

import { ref } from 'vue';
import { langTextMap, getLanguage, setLanguage } from '@/lang/index';

// 获取当前语言text

const __default__ = {
  name: 'LanguagePicker'
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentLangTitle = ref(langTextMap[getLanguage()]);

// 切换语言：仅持久化后 reload，不更新 locale，避免词条闪烁
const handleChangeLanguage = (val: string) => {
  setLanguage(val as any, { persistOnly: true });
  location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    onCommand: handleChangeLanguage,
    "popper-class": "lang-dropdown",
    trigger: "click",
    size: "default"
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langTextMap), (item, key) => {
            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: key,
              command: key,
              disabled: item === currentLangTitle.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1032, ["command", "disabled"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          style: {"margin-right":"6px","height":"14px"},
          alt: ""
        }, null, -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(currentLangTitle.value), 1)
      ])
    ]),
    _: 1
  }))
}
}

})